// extracted by mini-css-extract-plugin
export var formContainer = "_iv-0";
export var message = "_iv-1";